import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

interface MobilePageHeaderProps {
  title: string
  subtitle?: string
  actions?: ReactNode
}

export function MobilePageHeader({ title, subtitle, actions }: MobilePageHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-3 border-b border-line bg-bg-2 px-4 py-2.5">
      <button
        onClick={() => navigate(-1)}
        className="rounded-[8px] p-1.5 text-paper-dim transition-colors hover:bg-bg-3 hover:text-paper"
        aria-label="Go back"
      >
        <ArrowLeft size={18} />
      </button>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-[14px] font-semibold tracking-[-0.005em] text-paper">
          {title}
        </h1>
        {subtitle && <p className="truncate text-[11px] text-paper-dim">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
